"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Product price information summary transformer.
 */
var ProductPriceInformationSummaryTransformer = /** @class */ (function () {
    function ProductPriceInformationSummaryTransformer() {
    }
    /**
     * Extracts the information from the sales price of a product and puts it into properties that are easier to interpret.
     *
     * @param priceInformation Product price information.
     * @returns Product price information summary.
     */
    ProductPriceInformationSummaryTransformer.transform = function (priceInformation) {
        var returnValue = {
            temporaryFamilyPrice: false,
            newLowerPrice: false,
            timeRestrictedOffer: false,
            familyPrice: null,
            price: null,
            regularPrice: null
        };
        if (!(priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.salesPrice)) {
            return returnValue;
        }
        for (var _i = 0, _a = priceInformation.salesPrice; _i < _a.length; _i++) {
            var salesPrice = _a[_i];
            if (salesPrice.typeCode === 'IKEAFamilySalesUnitPrice') {
                returnValue.familyPrice = salesPrice;
                if (salesPrice.changeReason && salesPrice.changeReason === 'Temporary') {
                    returnValue.temporaryFamilyPrice = true;
                }
            }
            else if (salesPrice.changeReason && salesPrice.changeReason === 'NewLowerPrice') {
                returnValue.newLowerPrice = true;
                returnValue.price = salesPrice;
            }
            else if (salesPrice.changeReason && salesPrice.changeReason === 'TimeRestrictedOffer') {
                returnValue.timeRestrictedOffer = true;
                returnValue.price = salesPrice;
                if (salesPrice.previousSalesPrice) {
                    returnValue.regularPrice = Object.assign({}, salesPrice, salesPrice.previousSalesPrice);
                }
            }
            else if (priceInformation.salesPrice.length > 1) {
                returnValue.regularPrice = salesPrice;
            }
            else {
                returnValue.price = salesPrice;
            }
        }
        if (!returnValue.price && returnValue.regularPrice) {
            returnValue.price = returnValue.regularPrice;
        }
        return returnValue;
    };
    return ProductPriceInformationSummaryTransformer;
}());
exports.default = ProductPriceInformationSummaryTransformer;
//# sourceMappingURL=ProductPriceInformationSummaryTransformer.js.map